<template>
  <div class="history">
    <!-- <span class="font-red"
			>每个文件下载后，将为您保存72小时，点击重新下载即可
		</span>
		<el-tabs v-model="currentValue" class="tabs-list">
			<el-tab-pane
				v-for="(o, oIndex) in tabList"
				:key="oIndex"
				:label="o.label"
				:name="o.name"
				class="tabs-content"
				v-loading="tableLoading"
			>
				<Table
					:obj="o.data"
					@sizeChange="sizeChange"
					@pageChange="pageChange"
					@refreshChange="refreshChange"
				/>
			</el-tab-pane>
		</el-tabs> -->
    <CartsTitle title="我的收藏" v-if="isShowTitle" />
    <div class="table-container">
      <Table
        :obj="tabList[0].data"
        @sizeChange="sizeChange"
        @pageChange="pageChange"
        @refreshChange="refreshChange"
      />
    </div>
  </div>
</template>

<script>
import Table from "./module/table.vue";
import { cartsList } from "../../api/order";
import CartsTitle from "@/components/CartsTitle.vue";
import {
  setToken,
  getTempUser,
  getToken,
  getNewUser,
} from "../../utils/storage";
export default {
  components: {
    Table,
    CartsTitle,
  },
  props: {
    isShowTitle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentValue: "first",
      tabList: [
        {
          label: "我的收藏",
          name: "first",
          data: {},
        },
      ],
      tableLoading: false,
      pageNo: 1,
      pageSize: 50,
    };
  },
  mounted() {
    this.getTableDatas();
    this.$EventBus.$on("refresh", (data) => {
      //将A组件传递过来的参数data赋值给msgB
      if (data == "1") {
        this.getTableDatas();
      }
    });
    // if (getNewUser() == 0) {
    //   this.$store.commit("updateShowBottum", true);
    //   this.$store.commit("updateShowPost", true);
    // }
  },
  destroyed() {
    this.$EventBus.$off("refresh");
  },
  methods: {
    getTableDatas() {
      this.tableLoading = true;
      this.tabList.forEach((item, index) => {
        let dataform = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        };
        cartsList(dataform)
          .then((result) => {
            this.tableLoading = false;
            result.datalists.forEach((item1) => {
              item1.icon = item1.icon.replace(
                "www.shutterstock.com",
                "img.tukuwu.com"
              );
              item1.describe =
                "https://img.aatuku.com/preview260/" + item1.recCode + ".jpg";
              item1.isDown = false;
              item1.downUrl = "";
              item1.downUrl1 = "";
            });
            item.data = result;
          })
          .catch((error) => {
            this.tableLoading = false;
          });
      });
    },
    typeFormat(row) {
      if (row.format === "4") {
        return "EPS矢量";
      } else {
        return "JPG大图";
      }
    },
    pageChange(params) {
      this.pageNo = params;
      this.getTableDatas();
    },
    sizeChange(param) {
      this.pageSize = param;
      this.pageNo = 1;
      this.getTableDatas();
    },
    refreshChange() {
      this.getTableDatas();
    },
  },
};
</script>

<style lang="scss" scoped>
.font-red {
  color: #909399;
  float: right;
  margin-top: 12px;
}

.table-container {
  background-color: white;
  padding: 30px;
}

.history {
  width: 100%;
}
</style>
